import { useErrorHandling } from '@/composables/use-error-handling'
import errorMessages from '@/error-messages'
import { getApiErrorMessage } from '@/utils/api'
import type { CreatedPublicShortUrlRecord, PublicShortUrlRecord } from '@/website/types'
import type { APIResponse } from '@/website/types/api'
import axios, { isAxiosError, type GenericAbortSignal } from 'axios'
import endpoints from './endpoints'

export const publicShortUrlsApi = {
    create: async (
        destinationUrl: string,
    ): Promise<[CreatedPublicShortUrlRecord | undefined, string]> => {
        const request = axios.post<APIResponse<CreatedPublicShortUrlRecord>>(
            endpoints.PUBLIC_SHORT_URLS_V1,
            {
                destinationUrl,
            },
        )

        try {
            const response = await useErrorHandling(request)
            return [response.data.data, '']
        } catch (error) {
            let errorMessage = errorMessages.UNEXPECTED_ERROR

            if (isAxiosError<APIResponse>(error)) {
                const response = error.response?.data

                const isForbiddenUrl = response?.messages.some(
                    (x) => x === 'ForbiddenDestinationurl',
                )

                if (isForbiddenUrl) {
                    errorMessage = 'Oops, unfortunately this URL is not an allowed URL'
                }
            }

            return [undefined, errorMessage]
        }
    },
    getLatest: async (
        takeCount?: number,
        signal?: GenericAbortSignal,
    ): Promise<[PublicShortUrlRecord[], string]> => {
        const request = axios.get<APIResponse<PublicShortUrlRecord[]>>(
            `${endpoints.PUBLIC_SHORT_URLS_V1}/latest`,
            {
                params: {
                    takeCount,
                },
                signal,
            },
        )

        try {
            const response = await useErrorHandling(request)
            return [response.data.data, '']
        } catch (error) {
            return [[], getApiErrorMessage(error)]
        }
    },
}
